import React, { useEffect, useRef, useState } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useDispatch, useSelector } from "react-redux";
import {
  getPurchaseReturn,
  getPurchaseReturnByMonth,
} from "../../Redux/Feature/PurchaseReturn/purchaseReturnAction";
import { Autocomplete, TextField } from "@mui/material";
const { adToBs } = require("@sbmdkl/nepali-date-converter");

const drawerWidth = 360;

const PurchaseReturnTable = ({ TableData }) => {
  const [tableWidth, setTableWidth] = useState("100%");

  useEffect(() => {
    const screenWidth = window.innerWidth;
    const calculatedWidth = screenWidth - drawerWidth;
    setTableWidth(`${calculatedWidth}px`);
  }, []);

  const tableRef = useRef(null);
  const dispatch = useDispatch();

  const token = localStorage.getItem("NHHD:token");

  const { purchaseReturn, purchaseReturnByMonth } = useSelector(
    (state) => state.purchaseReturn
  );
  const { data } = useSelector((state) => state.products);
  const { supplies } = useSelector((state) => state.supplier);

  console.log(supplies);
  const [selectedItem, setSelectedItem] = React.useState(null);

  // Create a map of product IDs to product names
  const productMap = new Map();
  data.forEach((product) => {
    product.purchaseFrom.forEach((purchaseInfo) => {
      productMap.set(purchaseInfo._id, purchaseInfo.productName);
    });
  });
  console.log(data);

  console.log(productMap);
  // Loop through sale returns and extract product names
  const extractedProductNames = [];
  purchaseReturnByMonth?.forEach((items) => {
    items.particularName.forEach((item) => {
      const productName = productMap.get(item.productId);
      console.log(item.productId);
      console.log(productName);
      if (productName) {
        extractedProductNames.push(productName);
      }
    });
  });
  console.log(extractedProductNames);

  const supplierMap = new Map();
  supplies.forEach((supplier) => {
    supplierMap.set(supplier._id, supplier.supplierName);
  });
  // Loop through sale returns and extract supplier names
  const extractedsupplierNames = [];
  purchaseReturnByMonth?.forEach((purchaseReturn) => {
    const supplierName = supplierMap.get(purchaseReturn.supplierId);
    if (supplierName) {
      extractedsupplierNames.push(supplierName);
    }
  });

  console.log(extractedsupplierNames);

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so add 1
  const day = String(today.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  const dateInBS = adToBs(formattedDate);

  const monthInBS = parseInt(dateInBS.slice(5, 7)) - 1;
  const yearInBS = dateInBS.slice(0, 4);

  const currentMonthInBS = monthOrder[monthInBS];

  const currentDate = currentMonthInBS + "-" + yearInBS;

  const combinedMonth = purchaseReturn?.map((item) => {
    return item.purchaseReturnMonth && item.purchaseReturnMonth;
  });

  const uniqueSet = new Set(combinedMonth);
  // Convert the Set back to an array to maintain order
  const uniqueMonth = Array.from(uniqueSet);

  const defaultMonthIndex = uniqueMonth.indexOf(currentDate);

  const [selectedMonth, setSelectedMonth] = React.useState(currentDate);

  const handleOptionChange = (event, value) => {
    if (value) {
      console.log("Selected option object:", value);
      setSelectedMonth(value);
    } else {
      // console.log("Selected option cleared");
      setSelectedMonth(null);
    }
  };

  useEffect(() => {
    async function fetch() {
      dispatch(getPurchaseReturn({ token }));
      dispatch(
        getPurchaseReturnByMonth({ token, selectedItem: selectedMonth })
      );
    }
    fetch();
  }, [dispatch, token, selectedMonth]);

  return (
    <div className="w-full">
      <div className="w-[300px] my-4 mx-4">
        <Autocomplete
          options={uniqueMonth}
          defaultValue={currentDate}
          value={selectedMonth}
          getOptionLabel={(item) => {
            return item;
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select an option"
              variant="filled"
              className="w-24" // Adjust the width value using Tailwind CSS classes
            />
          )}
          onChange={handleOptionChange}
          sx={{ mt: 1 }}
        />
      </div>
      <section class="container p-4 mx-auto " style={{ width: tableWidth }}>
        <p className="text-end">
          <DownloadTableExcel
            filename="users table"
            sheet="users"
            currentTableRef={tableRef.current}
          >
            <button className=" text-[green] border  border-[gray]  rounded-[4px] p-2 hover:bg-[green] hover:text-white">
              Export to Excel
            </button>
          </DownloadTableExcel>
        </p>
        <div ref={tableRef}>
          <div class="flex flex-col items-center justify-center my-2">
            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                <div class="overflow-hidden md:rounded-lg">
                  <table
                    class="min-w-auto border-collapse"
                    id="purchase-account-table-to-xls"
                  >
                    <tbody class="bg-white">
                      <tr className="flex flex-col items-center">
                        <td
                          className="text-xl font-semibold flex flex-col items-center"
                          colSpan={18}
                        >
                          खरिद फिर्ता खाता
                        </td>
                      </tr>
                      <tr className="text-md">
                        <td className="text-md" colSpan={18}>
                          (नियम २३ को उपनियम (१) को खण्ड (छ) संग सम्बन्धित )
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="font-medium flex flex-col items-center justify-center"
                          colSpan={18}
                        >
                          <div>करदाता दर्ता नं :hjkl</div>
                          <div>करदाताको नाम :hvjk</div>
                          <div>
                            साल :
                            {selectedItem !== null
                              ? selectedItem?.slice(-4) +
                                "/" +
                                parseInt(parseInt(selectedItem?.slice(-2)) + 1)
                              : null}
                          </div>
                          <div>
                            कर अवधि :
                            {selectedItem !== null
                              ? selectedItem?.replace(/-.*/, "")
                              : null}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-col ">
            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                <div class="overflow-hidden border border-gray-200 md:rounded-lg">
                  <table
                    class="min-w-auto divide-y border-spacing-0 divide-gray-200 "
                    id="purchase-account-table-to-xls"
                  >
                    <thead class="bg-gray-50">
                      <tr>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          colSpan={8}
                        >
                          बीजक / प्रज्ञापनपत्र नम्बर
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          rowSpan={2}
                        >
                          जम्मा फिर्ता मूल्य (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          rowSpan={2}
                        >
                          कर छुट हुने वस्तु वा सेवाको फिर्ता मूल्य (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          colSpan={2}
                        >
                          करयोग्य फिर्ता (पूंजीगत बाहेक)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          colSpan={2}
                        >
                          करयोग्य पैठारी फिर्ता (पूंजीगत बाहेक)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          colSpan={2}
                        >
                          पूंजीगत करयोग्य फिर्ता
                        </th>
                      </tr>
                      <tr>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          मिति
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          बीजक नं.
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          प्रज्ञापनपत्र नं.
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          आपूर्तिकर्ताको नाम
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          आपूर्तिकर्ताको स्थायी लेखा नम्बर
                        </th>

                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          खरिद/पैठारी फिर्ता गरिएका वस्तु वा सेवाको विवरण
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          खरिद/पैठारी फिर्ता गरिएका वस्तु वा सेवाको परिमाण
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          वस्तु वा सेवाको एकाई
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          मूल्य (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          कर (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          मूल्य (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          कर (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          मूल्य (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          कर (रु)
                        </th>
                      </tr>
                    </thead>

                    <tbody class="bg-white divide-y divide-gray-200    ">
                      {purchaseReturnByMonth === undefined
                        ? "No product in the list"
                        : purchaseReturnByMonth?.map((item, i) => {
                            const totalQuantity = item.particularName.map(
                              (item, i) => {
                                return item.productQuantity;
                              }
                            );

                            const totalImportAmount =
                              item?.purchaseImported?.VATamountImport &&
                              item?.purchaseImported?.VATamountImport !== null
                                ? item?.purchaseImported?.VATamountImport / 0.13
                                : null;

                            console.log(totalImportAmount, "h");

                            return (
                              <>
                                <tr key={i}>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{item.returnPurchaseDate}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item.billNo && item.billNo
                                          ? item.billNo
                                          : "-"}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item.importBillNumber &&
                                        item.importBillNumber
                                          ? item.importBillNumber
                                          : "-"}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{extractedsupplierNames[0]}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{item.registrationNumber}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{extractedProductNames[0]}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item.particularName[0]
                                          .productQuantity &&
                                        item.particularName[0].productQuantity
                                          ? totalQuantity
                                          : "1"}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item.particularName[0].productSKU}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item.totalAmountWithTax}
                                        {/* {item.purchase && item.purchase
                                          ? item.purchase.amountWithTax
                                          : item?.purchaseImported
                                              ?.totalImportAmount !== null
                                          ? totalImportAmount
                                          : item.assest && item.asset
                                          ? item.asset.totalAmount
                                          : "-"} */}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item.nonTaxableAmount
                                          ? item.nonTaxableAmount
                                          : "-"}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{item.amountExcludeTax}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span> {item.vatAmount}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        -
                                        {/* {item?.purchaseImported
                                          ?.totalCosting !== null
                                          ? item?.purchaseImported
                                              ?.totalAmountExcludingVAT
                                          : "-"} */}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        -
                                        {/* {item?.purchaseImported
                                          ?.totalCosting !== null
                                          ? item?.purchaseImported
                                              ?.VATamountImport
                                          : "-"} */}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {" "}
                                        {item.assest && item.assest
                                          ? item.assest.amountWithTax
                                          : "-"}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item.assest && item.assest
                                          ? item.assest.taxAmount
                                          : "-"}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                      <tr>
                        <td class="px-4 py-4 text-lg font-semibold text-gray-700   whitespace-nowrap">
                          <div class="inline-flex items-center px-4 gap-x-3">
                            <span>Total:</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PurchaseReturnTable;

const monthOrder = [
  "बैशाख",
  "जेठ",
  "असार",
  "श्रावण",
  "भाद्र",
  "असोज",
  "कार्तिक",
  "मंसिर",
  "पुष",
  "माघ",
  "फागुन",
  "चैत्र",
];
